import React from 'react'
import { Text, Square } from '@chakra-ui/react'

export const Letter = ({
  letter,
  selectedLetter,
  setSelectedLetter,
}: {
  letter: string
  selectedLetter: string
  setSelectedLetter: (val: string) => void
}) => (
  <Square
    borderWidth={'1.5px'}
    borderStyle={'solid'}
    borderColor={selectedLetter === letter ? 'blue.200' : '#EAEEF4'}
    borderRadius={'2px'}
    size={'52px'}
    onClick={() => (letter !== '...' ? setSelectedLetter(letter) : null)}
    background={'#FFFFFF'}
    cursor={'pointer'}
    as={'button'}
    textStyle={'placeholder'}
    color={selectedLetter === letter ? 'blue.200' : 'gray.500'}
  >
    {letter}
  </Square>
)
